import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding-bottom: 40px;
`;

export const PageBanner = styled.section`
  background: linear-gradient(135deg, #1A1A1A 0%, #0f0f1a 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 24px 24px 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  .page-title {
    font-size: 20px;
    font-weight: 800;
    color: #f1f5f9;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
    svg { color: #9333EA; font-size: 20px; }
  }
  .page-sub { font-size: 12.5px; color: #6b7280; }

  .verify-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    font-size: 11.5px;
    color: #9ca3af;
    max-width: 520px;
    line-height: 1.5;

    svg { color: #a78bfa; font-size: 13px; flex-shrink: 0; }
  }

  .banner-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    flex-wrap: wrap;
  }

  .add-video-btn, .verify-btn {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 11px 20px;
    background: #9333EA;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    flex-shrink: 0;
    align-self: flex-start;
    text-decoration: none;
    transition: background 0.18s, transform 0.15s;

    &:hover { background: #6d28d9; transform: translateY(-1px); }
    svg { font-size: 15px; }
  }

  .verify-btn {
    background: #5865f2;
    &:hover { background: #4752c4; }
  }
`;

export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: #111;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;

  .search-wrap {
    position: relative;
    width: 200px;
    flex-shrink: 0;

    svg {
      position: absolute;
      inset-inline-start: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #4b5563;
      font-size: 13px;
      pointer-events: none;
    }

    input {
      width: 100%;
      background: #1A1A1A;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 7px;
      padding-block: 8px;
      padding-inline-start: 32px;
      padding-inline-end: 12px;
      color: #e2e8f0;
      font-size: 12.5px;
      font-family: inherit;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder { color: #4b5563; }
      &:focus { border-color: rgba(147, 51, 234, 0.5); }
    }
  }

  .filter-pills {
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  .sort-select {
    background: #1A1A1A;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 7px;
    padding: 8px 12px;
    color: #9ca3af;
    font-size: 12px;
    font-family: inherit;
    cursor: pointer;
    outline: none;
    flex-shrink: 0;
    transition: border-color 0.18s;

    &:focus { border-color: rgba(147, 51, 234, 0.5); color: #e2e8f0; }
    option { background: #1A1A1A; }
  }
`;

export const FilterBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? 'rgba(147,51,234,0.18)' : 'transparent'};
  color: ${props => props.active ? '#a78bfa' : '#6b7280'};
  font-size: 11.5px;
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.16s;

  svg { font-size: 12px; }
  &:hover { border-color: rgba(147,51,234,0.4); color: #e2e8f0; }
`;

export const CreatorsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  padding: 18px 20px;

  @media (max-width: 1000px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 720px)  { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px)  { grid-template-columns: 1fr; }
`;

export const CreatorCard = styled.div`
  background: #1A1A1A;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: border-color 0.18s, transform 0.15s, box-shadow 0.18s;
  cursor: pointer;

  &:hover {
    border-color: rgba(147, 51, 234, 0.35);
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.35);
  }

  /* cover */
  .cover-strip {
    height: 68px;
    position: relative;
    background-size: cover;
    background-position: center;
  }

  /* avatar */
  .avatar-wrap {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    border: 3px solid #1A1A1A;
    padding: 2px;
    position: absolute;
    bottom: -33px;
    right: 14px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      display: block;
      border: 2px solid #1A1A1A;
    }
  }

  /* platform icon + verified check on cover top-left */
  .badges-corner {
    position: absolute;
    top: 9px;
    left: 9px;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .primary-badge {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
    flex-shrink: 0;
  }

  .verified-check {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #4ade80;
    background: rgba(22, 163, 74, 0.18);
    border: 1px solid rgba(74, 222, 128, 0.3);
    flex-shrink: 0;
  }

  /* body */
  .card-body {
    padding: 38px 14px 14px;
    direction: rtl;
  }

  .creator-name {
    font-size: 14px;
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .creator-tag {
    font-size: 10.5px;
    color: #6b7280;
    margin-bottom: 12px;
  }

  /* stats */
  .stats-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    margin-bottom: 12px;

    .stat-item {
      text-align: center;
      .stat-value { font-size: 13px; font-weight: 700; color: #e2e8f0; display: block; }
      .stat-label { font-size: 9.5px; color: #6b7280; }
    }
  }

  /* multi-platform links */
  .platform-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }

  .plt-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 10px;
    border-radius: 6px;
    border: none;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    flex-shrink: 0;
    transition: filter 0.16s, transform 0.14s;

    svg { font-size: 12px; }
    &:hover { filter: brightness(0.85); transform: translateY(-1px); }
  }
`;
